export default __webpack_public_path__ + "static/media/order_details_screenshot.b5e2939f.png";